export const formatPrice = (price, currency = 'SAR', options = {}) => {
  const { onRequest = false, onRequestLabel = 'على السوم' } = options;
  if (onRequest) return onRequestLabel;
  if (price === null || price === undefined || price === '') return '';
  const formatted = new Intl.NumberFormat('en-US').format(price);
  return `${formatted} ${currency === 'SAR' ? 'ر.س' : currency}`;
};

// Format number with commas for display in form inputs (returns string with commas)
export const formatNumberWithCommas = (value) => {
  if (!value && value !== 0) return '';
  const str = String(value).replace(/[^\d.]/g, '');
  if (!str) return '';
  const parts = str.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

// Parse a comma-formatted number string back to raw number string
export const parseFormattedNumber = (value) => {
  if (!value) return '';
  return String(value).replace(/,/g, '');
};

export const formatArea = (area) => {
  if (area === null || area === undefined || area === '') return '';
  return `${new Intl.NumberFormat('en-US').format(area)} م²`;
};

export const formatDate = (date, locale = 'ar-EG') => {
  if (!date) return '';
  return new Date(date).toLocaleDateString(locale, {
    calendar: 'gregory',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const formatRelativeTime = (date) => {
  if (!date) return '';
  const now = new Date();
  const past = new Date(date);
  const diffMs = now - past;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'الآن';
  if (diffMins < 60) return `منذ ${diffMins} دقيقة`;
  if (diffHours < 24) return `منذ ${diffHours} ساعة`;
  if (diffDays < 7) return `منذ ${diffDays} يوم`;
  return formatDate(date);
};

export const generateWhatsAppLink = (phone, message = '') => {
  const cleanPhone = phone.replace(/[^0-9]/g, '');
  const formattedPhone = cleanPhone.startsWith('966') ? cleanPhone : `966${cleanPhone.replace(/^0/, '')}`;
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${formattedPhone}${message ? `?text=${encodedMessage}` : ''}`;
};

export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
};

export const truncateText = (text, maxLength = 100) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const getPropertyTypeColor = (type) => {
  const colors = {
    villa: { bg: '#e8f5e9', text: '#2e7d32' },
    apartment: { bg: '#e3f2fd', text: '#1565c0' },
    land: { bg: '#fff3e0', text: '#e65100' },
    building: { bg: '#f3e5f5', text: '#7b1fa2' },
    commercial: { bg: '#fce4ec', text: '#c2185b' },
    duplex: { bg: '#e0f7fa', text: '#00838f' },
    floor: { bg: '#fbe9e7', text: '#bf360c' }
  };
  return colors[type] || { bg: '#f5f5f5', text: '#616161' };
};

export const getStatusColor = (status) => {
  const colors = {
    updated: { bg: 'rgba(40, 167, 69, 0.1)', text: '#28a745' },
    not_updated: { bg: 'rgba(220, 53, 69, 0.1)', text: '#dc3545' },
    new: { bg: 'rgba(0, 123, 255, 0.1)', text: '#007bff' },
    contacted: { bg: 'rgba(40, 167, 69, 0.1)', text: '#28a745' },
    inProgress: { bg: 'rgba(255, 193, 7, 0.1)', text: '#b8860b' },
    completed: { bg: 'rgba(40, 167, 69, 0.1)', text: '#28a745' },
    cancelled: { bg: 'rgba(220, 53, 69, 0.1)', text: '#dc3545' }
  };
  return colors[status] || { bg: '#f5f5f5', text: '#616161' };
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    return true;
  }
};

export const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const validatePhone = (phone) => {
  // Accept any phone number - no validation
  return true;
};

export const getPropertyTypeLabel = (type) => {
  switch(type) {
    case 'villa': return 'فيلا';
    case 'apartment': return 'شقة';
    case 'land': return 'أرض';
    case 'building': return 'عمارة';
    case 'duplex': return 'دوبلكس';
    case 'commercial': return 'تجاري';
    case 'floor': return 'دور';
    default: return type;
  }
};
